import React from 'react'
import Hero from './hero'
import Items from './items'

// Rebuilt on the new design system (Task 9). The old faqs.css import is dropped - the
// accordion is rebuilt entirely on site.css's FAQ banner (tokens, not the old fixed 1080px/
// px-based rules), same pattern Task 8 followed when it dropped services.css.
const Index = () => {
  return (
    <>
      <Hero/>
      <Items/>
    </>
  )
}

export default Index
